export default "__VITE_ASSET__196c47a3__"